'use strict';
var __importDefault = this && this.__importDefault || function (mod) {
    return mod && mod.__esModule ? mod : { 'default': mod };
};
Object.defineProperty(exports, '__esModule', { value: true });
const package_json_1 = __importDefault(require('../package'));
exports.EVALUATOR_VERSION = package_json_1.default.version;    //# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiU25hcHNob3QuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi8uLi9zcmMvZXZhbHVhdG9yL21vZGVscy9TbmFwc2hvdC50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7OztBQU1BLG1FQUF3QztBQXlCM0IsUUFBQSxpQkFBaUIsR0FBRyxzQkFBUyxDQUFDLE9BQU8sQ0FBQyJ9
